import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MoonshotState, moonshotFeatureKey } from './moonshot.reducer';

export const selectMoonshotState =
  createFeatureSelector<MoonshotState>(moonshotFeatureKey);

export const selectMoonshotEnabled = createSelector(
  selectMoonshotState,
  (state: MoonshotState) => state.moonshotEnabled
);

export const selectUserPatientId = createSelector(
  selectMoonshotState,
  (state: MoonshotState) => state.userPatientId
);
